import React, { ComponentType } from "react";
import { useParams } from "react-router-dom";

import { FetchDeviceController } from "./FetchDeviceController";

interface WithFetchDeviceControllerProps {
  deviceId?: string;
}

function withFetchDeviceController<P>(
  Wrapped: ComponentType<P & WithFetchDeviceControllerProps>,
) {
  const WithFetchDeviceController = ({
    deviceId,
    ...restProps
  }: P & WithFetchDeviceControllerProps) => {
    const params = useParams<{ deviceId: string }>();
    const resolvedDeviceId = deviceId ?? params.deviceId;

    if (!resolvedDeviceId) {
      return null;
    }

    return (
      <FetchDeviceController deviceId={resolvedDeviceId}>
        <Wrapped {...(restProps as P)} deviceId={resolvedDeviceId} />
      </FetchDeviceController>
    );
  };

  return WithFetchDeviceController;
}

export { withFetchDeviceController };
export default withFetchDeviceController;
